module.exports = __webpack_public_path__ + "media/student_lending_solutions/private-d5b8a0bc.png";